import { cn } from '@liza/ui/utils/cn';
import type { LucideProps } from 'lucide-react';
import { CARE_PLAN_SECTION_ICONS, carePlanSectionColor, type CarePlanSection } from './carePlanSections';

export interface CarePlanSectionIconProps extends LucideProps {
  section: CarePlanSection;
}

/**
 * A plan section's icon, in that section's colour. The colour that tells items apart on the day-view
 * ring is what says which section a heading belongs to here.
 */
export function CarePlanSectionIcon({
  section,
  className,
  style,
  ...props
}: CarePlanSectionIconProps): React.ReactElement {
  const Icon = CARE_PLAN_SECTION_ICONS[section];
  const color = carePlanSectionColor(section);
  return (
    <Icon
      data-testid={`care-plan-section-icon-${section}`}
      className={cn('size-4 shrink-0', className)}
      style={color ? { color, ...style } : style}
      aria-hidden="true"
      {...props}
    />
  );
}
